export enum DataMappingType {
  ComponentDataSubscription = 'component-data-subscription'
}
